import { useRef, useEffect } from 'react';

const VideoBg = ({
    url
  }: {
    url: string
  }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (videoRef.current) videoRef?.current?.play();
  }, [videoRef]);

  return (
    <video
      ref={videoRef}
      autoPlay={false}
      playsInline
      loop
      muted
      className={`absolute w-full h-full object-cover top-0 left-0 p-0 -z-10`}
    >
      <source src={url} />
    </video>
  );
};

export default VideoBg;
